import React from "react";

import { ServicesPricingOfferingIcon } from "./ServicesPricingOfferingIcon";
import {
  getServicesPricingOfferingIconPresentation,
  type ServicesPricingOfferingIconKey,
} from "./profileServicesPricingOfferingIcons";

export type ServicesPricingSkillIconProps = Readonly<{
  className?: string;
  iconKey: ServicesPricingOfferingIconKey;
}>;

export function ServicesPricingSkillIcon({
  className,
  iconKey,
}: ServicesPricingSkillIconProps) {
  const presentation = getServicesPricingOfferingIconPresentation(iconKey);
  return (
    <span
      className={className}
      style={{ backgroundColor: presentation.bg }}
    >
      <ServicesPricingOfferingIcon iconKey={iconKey} />
    </span>
  );
}
